import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'schemas',
    props: true,
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: ':id',
        name: 'schemasTableComponent',
        props: true,
        meta: {
          rootRouteName: 'schemas'
        },
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'schemas' }
  }
];
